export type AssetLibraryView = 'all' | 'bookmarks' | 'trash';

export const INITIAL_ASSET_LIBRARY_VIEW: AssetLibraryView = 'all';

export function getAssetLibrarySubViewTitle(
  libraryView: AssetLibraryView,
): string | null {
  if (libraryView === 'bookmarks') {
    return 'Bookmarks';
  }

  if (libraryView === 'trash') {
    return 'Trash';
  }

  return null;
}

export function isAssetLibrarySubView(
  libraryView: AssetLibraryView,
): libraryView is 'bookmarks' | 'trash' {
  return libraryView === 'bookmarks' || libraryView === 'trash';
}
